import { useEffect, useState } from "react";

import useSWR from "swr/immutable";

import { yotpoReviewsAPIFetcher } from "@react/hooks/fetchers";
import { useSectionSettings } from "@react/sections/Root/SectionSettingsContext";
import {
  type YotpoReviewsAPIConnection,
  type ProductReviewsSettings,
} from "@root/tablescape/state";

type YotpoReviewsAPIParams = {
  direction?: "desc" | "asc";
  page?: string;
  per_page?: string;
  sort?: "date" | "votes_up" | "votes_down" | "time" | "rating" | "review_type";
  star?: 1 | 2 | 3 | 4 | 5;
};

export function useProductReviews(
  _productId: string,
  page: number,
  params: YotpoReviewsAPIParams = {}
) {
  const [productId, setProductId] = useState<string>();
  const {
    settings: { yotpoAppKey },
  } = useSectionSettings<ProductReviewsSettings>();

  useEffect(() => {
    if (process.env.STOREFRONT_ENV === "staging") {
      import("@root/scripts/product-id-map.json").then((productIdMap) => {
        const resolvedProductId = String(
          _productId
        ) as keyof typeof productIdMap.staging.products;

        setProductId(
          String(
            productIdMap.staging.products[resolvedProductId]?.destinationId ??
              _productId
          )
        );
      });
    }

    setProductId(_productId);
  }, [_productId]);

  const { data: productReviewsData, isLoading: reviewsAreLoading } =
    useSWR<YotpoReviewsAPIConnection>(
      productId && yotpoAppKey
        ? [
            yotpoAppKey,
            productId,
            {
              ...params,
              page: page.toString(),
              per_page: "5",
            },
          ]
        : null,
      yotpoReviewsAPIFetcher
    );

  return {
    pagination: productReviewsData?.response?.pagination,
    reviews: productReviewsData?.response?.reviews,
    reviewsAreLoading,
    groupingData: productReviewsData?.response?.grouping_data,
  };
}
